import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../../airport/models/airport.model';
import { BusinessManagerService } from '../user/business-manager.service';
import { AuthService } from '../../auth/auth/auth.service';
import { FlightbridgeService } from '../services/flightbridge.service';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';
import { AviationEvent } from '../models/aviation-event.model';
import * as moment from 'moment-timezone';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';

@Component({
  selector: 'app-flightbridge',
  templateUrl: './flightbridge.component.html',
  styleUrls: ['./flightbridge.component.scss']
})
export class FlightbridgeComponent implements OnInit {
  @Input() airport: Airport = null;
  @Input() aviationEvent: AviationEvent = null;
  isLoggedIn = false;
  isMember = false;

  constructor(
              private _businessManagerService: BusinessManagerService,
              private _auth: AuthService,
              private _flightbridgeService: FlightbridgeService,
              private _analyticsService: AnalyticsService) { }

  async ngOnInit() {
    if (this._auth.authenticated && this._auth.endUser) {
      this.isLoggedIn = true;
      this.isMember = await this._businessManagerService.isMember();
    }
  }

  async navigateToFlightBridge(pageType: string) {
    const ssoRetval = await this._flightbridgeService.postFlightBridgeSSOInitial();
    let firstDateString = null;
    let nextDateString = null;
    if (this.aviationEvent && this.aviationEvent.startDateTime && this.aviationEvent.endDateTime) {
      const startMoment = moment.tz(this.aviationEvent.startDateTime, 'UTC');
      firstDateString = startMoment.clone().tz(this.aviationEvent.timezone).format('YYYY-MM-DD');
      const endMoment = moment.tz(this.aviationEvent.endDateTime, 'UTC');
      nextDateString = endMoment.clone().tz(this.aviationEvent.timezone).format('YYYY-MM-DD');
    } else {
      const firstDate = new Date();
      firstDate.setDate(firstDate.getDate() + 1);
      firstDateString = formatDate(firstDate, 'yyyy-MM-dd', 'en-US');
      const nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + 3);
      nextDateString = formatDate(nextDate, 'yyyy-MM-dd', 'en-US');
    }
    let airportIdent = null;
    if (this.airport) {
      airportIdent = this.airport.faaId;
    } else if (this.aviationEvent && this.aviationEvent.airportIdent) {
      airportIdent = this.aviationEvent.airportIdent;
    }
    let URL = '';
    if (pageType === 'hotel') {
      this._analyticsService.trackEvent('airport_flightbridge_hotel', '', '');
      if (airportIdent) {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeHotelUrl}&UserAuthenticationToken=${ssoRetval.token}&AirportCode=${airportIdent}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
        this._analyticsService.trackEvent('airport_flightbridge_hotel-specific', airportIdent, airportIdent);
      } else {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeAnywhereHotelUrl}&UserAuthenticationToken=${ssoRetval.token}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
      }
    } else if (pageType === 'rentalcar') {
      this._analyticsService.trackEvent('airport_flightbridge_rentalcar', '', '');
      if (airportIdent) {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeRentalCarUrl}&UserAuthenticationToken=${ssoRetval.token}&AirportCode=${airportIdent}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
        this._analyticsService.trackEvent('airport_flightbridge_rentalcar-specific', airportIdent, airportIdent);
      } else {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeAnywhereRentalCarUrl}&UserAuthenticationToken=${ssoRetval.token}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
      }
    } else {
      // tslint:disable-next-line:max-line-length
      URL = `${environment.flightBridgeAirlineUrl}&UserAuthenticationToken=${ssoRetval.token}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
      this._analyticsService.trackEvent('airport_flightbridge_airline', '', '');
    }
    window.open(URL);
  }

  navigateToJoinAOPA() {
    window.open('https://www.aopa.org/account/multipagejoin');
  }

  navigateToLogin() {
    window.open('https://www.aopa.org/login');
  }
}
